import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconBirdLogo from 'components/icons/iconBirdLogo';
import useScreen from 'hooks/useScreen';
import SliderStandard from './Slider';
const CustomerPhotosSlider = props => {
  const $ = _c(17);
  const {
    imageArray,
    visibleSlides,
    navType,
    logo,
    imageWidth,
    imageHeight,
    title,
    description,
    updateImageArraySize,
    slideIndex
  } = props;
  let finalVisibleSlides = visibleSlides ? visibleSlides.content ? visibleSlides.content : visibleSlides : 0;
  const {
    isMobileOrTablet
  } = useScreen();
  if (isMobileOrTablet) {
    finalVisibleSlides = 1;
  }
  let t0;
  if ($[0] !== logo || $[1] !== title) {
    t0 = title && <div className="text-2xl text-gray font-bold flex flex-col-reverse mb-6 lg:mt-0 lg:mx-0 lg:mb-8 lg:flex-row lg:items-center">{title}{logo && <div className="text-base text-gray mb-2 lg:mt-2 lg:mr-0 lg:mb-0 lg:ml-5 [&_svg]:scale-150 [&_svg]:mx-[.3rem] [&_svg]:my-0"><IconBirdLogo color="#27919C" /> {logo}</div>}</div>;
    $[0] = logo;
    $[1] = title;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== description) {
    t1 = description && <div className="text-base max-w-[500px] mb-12">{description}</div>;
    $[3] = description;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== finalVisibleSlides || $[6] !== imageArray || $[7] !== imageHeight || $[8] !== imageWidth || $[9] !== navType || $[10] !== slideIndex || $[11] !== updateImageArraySize) {
    t2 = <SliderStandard finalVisibleSlides={finalVisibleSlides} imageHeight={imageHeight} imageWidth={imageWidth} navType={navType} imageArray={imageArray} updateImageArraySize={updateImageArraySize} slideIndex={slideIndex} />;
    $[5] = finalVisibleSlides;
    $[6] = imageArray;
    $[7] = imageHeight;
    $[8] = imageWidth;
    $[9] = navType;
    $[10] = slideIndex;
    $[11] = updateImageArraySize;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== t0 || $[14] !== t1 || $[15] !== t2) {
    t3 = <div>{t0}{t1}{t2}</div>;
    $[13] = t0;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
};
CustomerPhotosSlider.propTypes = {
  description: PropTypes.string,
  imageArray: PropTypes.array,
  imageHeight: PropTypes.number,
  imageWidth: PropTypes.number,
  logo: PropTypes.string,
  navType: PropTypes.string,
  slideIndex: PropTypes.number,
  title: PropTypes.string,
  updateImageArraySize: PropTypes.func,
  visibleSlides: PropTypes.shape({
    content: PropTypes.number
  })
};
export default CustomerPhotosSlider;